export default __webpack_public_path__ + "static/lightsOff-eed945c9a3804325aa28358c0631b358.jpg";